import { call, put, takeEvery } from "redux-saga/effects";

import {
  INFORMEIMAGE_LISTA,
  INFORMEIMAGE_LIST,
  INFORMEIMAGE_FILTER,
  INFORMEIMAGE_CREATE,
  INFORMEIMAGE_UPDATE,
  INFORMEIMAGE_READ,
  INFORMEIMAGE_DELETE,
} from "./actionTypes";

import {
  
  informeImageListSuccess,
  informeImageCreateSuccess,
  informeImageUpdateSuccess,
  informeImageRequestFailed,
  informeImageDeleteSuccess,
 
} from "./actions";

import {
  getInformeImageList,
  getInformeImageFullList,
  getInformeImageFilter,
  getInformeImageRead,
  postInformeImageCreate,
  patchInformeImageUpdate,
  deleteInformeImage,
} from "../../helpers/backend";



function*informeImageListSaga() {
  console.log("Trayendo lista de informeImage...");
  try {
    const response = yield call(getInformeImageList);
    if (response.status === 200) {
      yield put(informeImageListSuccess(response.data));
    } else {
      yield put(informeImageRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}

function*informeImageListaSaga() {
  console.log("Trayendo lista de informeImage...");
  try {
    const response = yield call(getInformeImageFullList);
    if (response.status === 200) {
      yield put(informeImageListSuccess(response.data));
    } else {
      yield put(informeImageRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}

function*informeImageCreateSaga({ payload:informeImage }) {
  console.log("Creando nuevo informeImage...");
  try {
    const response = yield call(postInformeImageCreate,informeImage);
    if (response.status === 201) {
      yield put(informeImageCreateSuccess(response.data));
    } else {
      yield put(informeImageRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}

function*informeImageFilterSaga({ payload: { changeUrl } }) {
  console.log("Trayendo informe filtrado")
  try {
    const response = yield call(getInformeImageFilter, { changeUrl });
    if (response.status === 200) {
      yield put(informeImageListSuccess(response.data));
     
    } else {
      yield put(informeImageRequestFailed(response.data));
      
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}

function*informeImageUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");
  try {
    const response = yield call(patchInformeImageUpdate, { id }, data);
    if (response.status === 200) {
      yield put(informeImageUpdateSuccess(response.data));
    } else {
      yield put(informeImageRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}

function*informeImageReadSaga({ payload: { id, data } }) {
  console.log("Trayendo el read.");
  try {
    const response = yield call(getInformeImageRead, { id });
    if (response.status === 200) {
      yield put(informeImageListSuccess(response.data));
    } else {
      yield put(informeImageRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}



function*informeImageDeleteSaga({ payload: { id } }) {
  console.log("Borrando datos de la Imagen...");
  try {
    const response = yield call(deleteInformeImage, id );
    if (response.status === 204) {
      yield put(informeImageDeleteSuccess(response.data));
    } else {
      yield put(informeImageRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informeImageRequestFailed(error.response.data));
  }
}




export default function*informeImageSaga() {
  yield takeEvery(INFORMEIMAGE_LIST,informeImageListSaga);
  yield takeEvery(INFORMEIMAGE_LISTA,informeImageListaSaga);
  yield takeEvery(INFORMEIMAGE_FILTER,informeImageFilterSaga);
  yield takeEvery(INFORMEIMAGE_CREATE,informeImageCreateSaga);
  yield takeEvery(INFORMEIMAGE_UPDATE,informeImageUpdateSaga);
  yield takeEvery(INFORMEIMAGE_READ,informeImageReadSaga);
  yield takeEvery(INFORMEIMAGE_DELETE,informeImageDeleteSaga);
}
